/* 
 *  Copyright © Ludvik Michalek, Bigfoot Interactive
 *  http://www.bigfoot.cz/
 */


// template IDs
var TEMPLATE_DEFAULT = 1;
var TEMPLATE_HOMEPAGE_P1 = 15;
var TEMPLATE_HOMEPAGE_P4 = 2;
var TEMPLATE_HOMEPAGE_PB = 16;
var TEMPLATE_CONTACT = 4;
var TEMPLATE_TEAM = 5;
var TEMPLATE_OFFICE_HOURS = 9;
var TEMPLATE_OFFICE_GALLERY = 11;
var TEMPLATE_CONSULTING = 20;


var page;
var templateId = parseInt(document.documentElement.getAttribute('data-template'));
var proficiencyRequired = parseInt(document.documentElement.getAttribute('data-proficiency-required')) === 1 ? true : false;


function updateVideoAspectRatio(){
	var videos = $('.video');
	if (videos.length) {
		videos.each(function(index) {
			var height = Math.round(($(this).width() / 16) * 9);
			$(this).height(height);
		});
	}
}


function getHeaderScrollOffset(){
	if (Gridle.isActive('mobile')) {
		var headerHeight = $('header').height();
		return -headerHeight;
	} else {
		return 0;
	}
}


$(document).ready(function () {
	var body = $('body');

	/*
	 * Template-specific init
	 */
	switch(templateId){
		case TEMPLATE_HOMEPAGE_P1:
		case TEMPLATE_HOMEPAGE_P4:
		case TEMPLATE_HOMEPAGE_PB:
			page = new HomepageController(body);
			break;

		case TEMPLATE_CONTACT:
			page = new ContactController(body);
			break;

		case TEMPLATE_CONSULTING:
			page = new ConsultingController(body);
			break;

		case TEMPLATE_TEAM:
			page = new TeamController(body);
			break;

		case TEMPLATE_OFFICE_GALLERY:
			page = new OfficeGalleryController(body);
			break;

		case TEMPLATE_DEFAULT:
			break;
	}
	

	/**
	 * Global init
	 */
	var mainMenu = new MainMenu($('header'));
	if($('#global-popup').length === 1) {
		var globalPopup = new GlobalPopup($('#global-popup'));
	}
	
	
	// proficiency required popup
	if(proficiencyRequired){
		var proficiencyPopup = new ProficiencyPopup($('#proficiency-popup'));
	}
	
	
	// object-fit css polyfill
	objectFitImages();

	// gridle and viewport handlers
	Gridle.on('update', function(updatedStates, activeStates, inactiveStates) {
		updateVideoAspectRatio();
	});
});

